<template>
  <div class="outside">
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="11" :lg="11">
          <div class="figure">
            <i class="icon icon-user"></i>
          </div>
        </el-col>
        <el-col :xs="24" :sm="13" :lg="13">
          <h2 class="text-light-blue">¿Olvidaste tu Clave?</h2>
          <el-form :model="model" :rules="rules" ref="form" class="mt-3">
            <el-form-item prop="email">
              <el-input v-model="model.email"
                        placeholder="Correo Electronico"></el-input>
            </el-form-item>
            <el-button type="primary"
                       class="pull-right mt-1"
                       :disabled="!model.email"
                       @click="login">Enviar Correo
            </el-button>
          </el-form>
        </el-col>
      </el-row>
      <el-alert
        v-if="error"
        class="mt-1"
        :title="error"
        type="error">
      </el-alert>
      <router-link to="login" class="text-dark-gray mt-1">Iniciar Sesi&oacute;n</router-link>
    </el-card>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        message: '',
        model: {
          email: ''
        },
        processing: false,
        error: false,
        success: false,
        rules: {
          email: [
            {
              required: true,
              message: 'El correo es requerido.',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: 'El correo tiene que ser valido.',
              trigger: 'change'
            }
          ]
        }
      }
    },
    methods: {
      login () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            const data = {
              email: this.model.email
            }
            this.processing = true
            this.message = ''
            this.error = ''
            this.$http.post('password/email', data)
              .then(
                (response) => {
                  const body = response.body
                  this.success = true
                  this.message = body.message
                  this.processing = false
                  this.error = false
                },
                (res) => {
                  if (typeof res.body === 'object') {
                    this.error = true
                    this.message = res.body.message
                    this.success = false
                  } else {
                    this.error = false
                    this.message = res.statusCode
                  }
                  this.processing = false
                }
              )
          } else {
            console.log('error submit!!')
            return false
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/Email.vue